import Loading from "../../assets/img/gif/gold_bitcoin.gif";
import Flex from "../flex";
import Image from "../image";

const LoadingBitcoinFlip = () => {
  return (
    <Flex
      flexColumn
      justifyContent="center"
      alignItems="center"
      className="h-100"
    >
      <Image src={Loading} alt={"Loading"} />
    </Flex>
  );
};

export default LoadingBitcoinFlip;
